import { API_URL } from '../config';
export const GetUserStatuses = async () => {
    try {
        return [
            {
                value: 'active',
                label: 'Active'
            },
            {
                value: 'deleted',
                label: 'Deleted'
            }
        ];

    } catch (error) {
        console.error('Error fetching user roles:', error);
        throw error;
    }
};